<template>
  <div style="background-color:#4C686C;" :style="'margin-top:' + margin + '%'">
    <div :style="(bigScreen ? 'width: 80%;' : '') + 'display: inline-block;'">
      <div
        data-aos="fade-up"
        data-aos-duration="2000"
        :style="bigScreen ? 'margin: 5%;' : 'margin: 5% 2%'"
      >
        <h1 :style="'font-size:' + size + 'em;'" class="bold">The Team</h1>
        <v-divider style="background-color: #ffffff; width: 20%;"></v-divider>
        <br />
        <div class="row">
          <div
            :style="
              bigScreen
                ? 'flex:30%'
                : 'flex: 100%;max-width: 100%;margin-top: 10%'
            "
            v-for="data in team.team"
            :key="data"
          >
            <div>
              <img
                :style="bigScreen ? 'width: 70%' : 'width: 50%'"
                :src="loadImg(data.imagem)"
              />
            </div>
            <h2 :style="'font-size:' + size2 + 'em;'" class="bold">
              {{ data.role }}
            </h2>
            <h2 :style="'font-size:' + size2 + 'em;'">{{ data.name }}</h2>
            <br />
          </div>
        </div>
        <br /><br />
      </div>
    </div>
  </div>
</template>

<script>
import json_pt from "./team.json";

export default {
  name: "AboutUs2",
  data() {
    return {
      team: json_pt,
      bigScreen: true,
      size: 5,
      size2: 1,
      size3: 0.5,
      margin: 20
    };
  },
  methods: {
    loadImg(imgPath) {
      return require("@/assets/images/team/" + imgPath);
    },
    update() {
      if (window.innerWidth > 1000) {
        this.bigScreen = true;
        this.margin = 20;
      } else if (window.innerWidth < 600) {
        this.bigScreen = false;
        this.margin = 90;
      } else {
        this.margin = 40;
      }
      var height = (window.innerWidth * 9) / 12;
      var ems = height / 20;
      this.size = ems / 20;
      this.size2 = 0.5 * this.size;
      this.size3 = 0.6 * this.size;
      if (this.size < 1.3) {
        this.size = 1.3;
        this.size2 = 1.2;
        this.size3 = 1;
      }
    }
  },
  mounted() {
    this.update();
    this.$options.interval = setInterval(this.update, 500);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  text-align: center;
  font-style: bold;
  font-size: 2em;
  line-height: 1em;
  letter-spacing: -0.05em;
  color: white;
}
h2 {
  text-align: center;
  font-style: bold;
  font-size: 1.3em;
  line-height: 1.4em;
  color: white;
}
p {
  text-align: justify;
}
a:hover {
  text-decoration-color: #828282;
}
v-lazy-image {
  object-fit: cover;
}
.rounded {
  background: #f1f1f1;
}
</style>
